module.exports = __webpack_public_path__ + "0c908df30fd8fe8efa2e4b43aeff90ed.pdf";